import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { type UseQueryOptions, useQueryWrapper } from '@trinity/chat-components/hooks/useQueryWrapper';
import type { AxiosResponse } from 'axios';
//import type { UseQueryOptions } from '@tanstack/react-query';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import type { TranscribeRT } from '@/types';
import type { TaggedMoment } from '@/types/transcribe.rich-text';

type KeyProps = {
  includeContent: boolean;
  tagIds?: number[];
} & ITranscriptId;

type Props = KeyProps;

function buildKey(data: KeyProps): QK {
  return ['transcript-tags', data] as const;
}

export const useTranscriptionTaggedMoments = (props: Props, options: Options = {}) => {

  const apiClient = useChatApiClient();

  const query = useQueryWrapper({
    queryKey: buildKey(props), queryFn: ({ queryKey }) => {
      const data = queryKey[1];

      return apiClient.transcripts.getTranscriptTaggedMoments(data)
        .then(res => res.items);
    },
    ...options,
  });

  return query;
};

type Data = TranscribeRT.TaggedMoment[];
type QK = readonly [string, KeyProps];

type Options = Omit<UseQueryOptions<Data, AxiosResponse, Data, QK>, 'queryKey' | 'queryFn'>;

type UpdateFn = (old: TaggedMoment[]) => TaggedMoment[];

export const useUpdateTranscriptionTags = (props: KeyProps) => {
  const queryClient = useQueryClient();

  return useCallback((updateFn: UpdateFn) => {
    queryClient.setQueryData(buildKey(props), updateFn);
  }, [queryClient, props]);
};